import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../../../../constants/report.css";
import { formatDate } from "../../../../constants/helper";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { ShowTableStokGudang } from "../../../../components/ShowTable";
import { FetchErrorHandling } from "../../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../../components";
import { Container, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Pagination,
  Button,
  ButtonGroup,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";

const TampilDaftarStokGudang = () => {
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();

  const [isFetchError, setIsFetchError] = useState(false);
  const [barangId, setBarangId] = useState("");
  const [kodeBarang, setKodeBarang] = useState("");
  const [namaBarang, setNamaBarang] = useState("");
  const [kuantitasStok, setKuantitasStok] = useState("");
  const [value, setValue] = useState("Semua");
  const [urut, setUrut] = useState("Kategori");

  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [stokGudangs, setStokGudangs] = useState([]);
  const [stokGudangsPagination, setStokGudangsPagination] = useState([]);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    id && getStokGudangById();
  }, [id]);

  useEffect(() => {
    getStokGudangsPagination();
  }, [page, searchTerm, value, urut]);

  const getStokGudangsPagination = async () => {
    setLoading(true);
    try {
      let tempUrlSwitch;
      switch (value) {
        case "Semua":
          switch (urut) {
            case "Kategori":
              tempUrlSwitch = "stokGudangsPagination";
              break;
            case "Abjad":
              tempUrlSwitch = "stokGudangsPaginationAbjad";
              break;
          }
          break;
        case "Ada Stok":
          switch (urut) {
            case "Kategori":
              tempUrlSwitch = "stokGudangsAdaStokPagination";
              break;
            case "Abjad":
              tempUrlSwitch = "stokGudangsAdaStokPaginationAbjad";
              break;
          }
          break;
        case "Stok Habis":
          switch (urut) {
            case "Kategori":
              tempUrlSwitch = "stokGudangsStokHabisPagination";
              break;
            case "Abjad":
              tempUrlSwitch = "stokGudangsStokHabisPaginationAbjad";
              break;
          }
          break;
      }

      const response = await axios.post(
        `${tempUrl}/${tempUrlSwitch}?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      setQuery(searchTerm);
      setStokGudangsPagination(response.data.stokGudangs);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getStokGudangs = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/stokGudangs`, {
        _id: user.id,
        token: user.token,
      });
      setStokGudangs(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getStokGudangById = async () => {
    if (id) {
      setLoading(true);
      const response = await axios.post(`${tempUrl}/stokGudangs/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setKodeBarang(response.data.barang.kodeBarang);
      setNamaBarang(response.data.barang.namaBarang);
      setKuantitasStok(response.data.kuantitasStok);
      const findBarang = await axios.post(`${tempUrl}/barangsByKodeBarang`, {
        kodeBarang: response.data.barang.kodeBarang,
        _id: user.id,
        token: user.token,
      });
      setBarangId(findBarang.data.id);
      setLoading(false);
    }
  };

  const deleteBarang = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteBarang/${barangId}`, {
        _id: user.id,
        token: user.token,
      });
      setSearchTerm("");
      setBarangId("");
      setKodeBarang("");
      setNamaBarang("");
      setKuantitasStok("");
      getStokGudangsPagination();
      navigate("/daftarStokGudang");
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${kodeBarang} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(14);
    doc.text(`Daftar Stok Gudang`, 85, 30);
    doc.setFontSize(8);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
      styles: {
        fontSize: 8,
      },
    });
    doc.save("daftarStokGudang.pdf");
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "StokGudang",
    sheet: "DaftarStokGudang",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  const textTableRight = {
    letterSpacing: "0.01px",
    textAlign: "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container>
      <h3>Stok</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar Stok Gudang</h5>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getStokGudangs();
              setPreviewPdf(!previewPdf);
              setPreviewExcel(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getStokGudangs();
              setPreviewExcel(!previewExcel);
              setPreviewPdf(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box>
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="styled-table" id="table" style={{ fontSize: "10px" }}>
            <thead>
              <tr>
                <th>Kode</th>
                <th>Nama</th>
                <th>Kuantitas</th>
              </tr>
            </thead>
            <tbody>
              {stokGudangs.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.barang.kodeBarang}</td>
                  <td>{user.barang.namaBarang}</td>
                  <td style={textTableRight}>
                    {user.kuantitasStok.toLocaleString("en-US")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table
          class="styled-table"
          id="table"
          style={{ fontSize: "10px" }}
          ref={tableRef}
        >
          {previewExcel && (
            <tbody>
              <tr>
                <th>Kode</th>
                <th>Nama</th>
                <th>Kuantitas</th>
              </tr>
              {stokGudangs.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.barang.kodeBarang}</td>
                  <td>{user.barang.namaBarang}</td>
                  <td style={textTableRight}>
                    {user.kuantitasStok.toLocaleString("en-US")}
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
      <FormControl sx={{ marginTop: 1 }}>
        <FormLabel id="demo-controlled-radio-buttons-group">Urut</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          defaultValue="Kategori"
          value={urut}
          onChange={(event) => setUrut(event.target.value)}
        >
          <FormControlLabel
            value="Kategori"
            control={<Radio />}
            label="Kategori"
          />
          <FormControlLabel value="Abjad" control={<Radio />} label="Abjad" />
        </RadioGroup>
      </FormControl>
      <br />
      <FormControl sx={{ marginTop: 1 }}>
        <FormLabel id="demo-controlled-radio-buttons-group">
          Kuantitas
        </FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          defaultValue="Semua"
          value={value}
          onChange={(event) => setValue(event.target.value)}
        >
          <FormControlLabel value="Semua" control={<Radio />} label="Semua" />
          <FormControlLabel
            value="Ada Stok"
            control={<Radio />}
            label="Ada Stok"
          />
          <FormControlLabel
            value="Stok Habis"
            control={<Radio />}
            label="Stok Habis"
          />
        </RadioGroup>
      </FormControl>
      {id && barangId && (
        <Box sx={buttonModifierContainer}>
          <ButtonModifier
            id={barangId}
            kode={barangId}
            addLink={null}
            editLink={`/daftarStokGudang/${barangId}/edit`}
            deleteUser={deleteBarang}
            nameUser={kodeBarang}
          />
        </Box>
      )}
      {id && (
        <Container>
          <hr />
          <Form>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRightSmall}>
                        Kode :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control value={kodeBarang} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRightSmall}>
                        Nama :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control value={namaBarang} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRightSmall}>
                        Kuantitas :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          value={kuantitasStok.toLocaleString("en-US")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Form>
        </Container>
      )}
      <hr />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableStokGudang currentPosts={stokGudangsPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilDaftarStokGudang;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};
